var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMasks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.8801 7.31721L21.6074 4.11718C21.5305 4.04298 21.4262 4.00216 21.3182 4.00352V4H7.40906C7.18304 4 7 4.17898 7 4.39997V27.6C7 27.821 7.18304 28 7.40906 28H24.5909C24.8169 28 25 27.821 25 27.6V7.6H24.9964C24.9971 7.4945 24.9554 7.39277 24.8801 7.31721ZM21.7273 5.36561L23.6034 7.20003H21.7273V5.36561ZM7.81821 27.2V4.80003H20.909V7.6C20.909 7.821 21.0922 7.99997 21.3182 7.99997H24.1818V27.2H7.81821Z",
    fill: "#74A3C7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 6.5H18.5V8.5H9.5V6.5Z",
    fill: "#74A3C7",
    stroke: "#74A3C7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 17H23V18H9V17Z",
    fill: "#74A3C7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9 20H23V21H9V20Z",
    fill: "#74A3C7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9 11H23V12H9V11Z",
    fill: "#74A3C7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9 14H23V15H9V14Z",
    fill: "#74A3C7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18 25H23V26H18V25Z",
    fill: "#74A3C7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMasks);
export default __webpack_public_path__ + "static/media/masks.36de78e22ca361279bfd828e8a863179.svg";
export { ForwardRef as ReactComponent };